(() => {
  const KEY = 'abmPopup';
  const SKIP = /^\/(cart|checkout|account|challenge|password)/;
  const store = {
    get() { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } },
    set(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  };
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let dialog = null, timer = null, shown = false;

  const otherOpen = () =>
    [...document.querySelectorAll('dialog[open]')].some((d) => d !== dialog) ||
    /abm-(cb|booking)-lock/.test(document.documentElement.className) ||
    document.querySelector('.abm-header-section.menu-open');

  const blocked = () => {
    const st = store.get();
    if (st.joined) return true;
    const mode = dialog.dataset.days;
    if (mode === 'session') { try { if (sessionStorage.getItem(KEY)) return true; } catch (e) {} }
    else if (mode !== '0' && st.until && Date.now() < st.until) return true;
    if (SKIP.test(location.pathname)) return true;
    if (dialog.dataset.mobile !== 'true' && window.matchMedia('(max-width: 759px)').matches) return true;
    return false;
  };

  const open = (force) => {
    if (!dialog || dialog.open || (!force && (shown || blocked()))) return;
    if (!force && otherOpen()) { timer = setTimeout(() => open(), 4000); return; }
    shown = true;
    document.documentElement.classList.add('abm-pop-lock');
    dialog.showModal();
    requestAnimationFrame(() => requestAnimationFrame(() => dialog.classList.add('is-visible')));
    dialog.querySelector('#AbmPopTitle')?.focus({ preventScroll: true });
  };

  const close = (remember = true) => {
    if (!dialog || !dialog.open) return;
    const mode = dialog.dataset.days;
    if (remember && !store.get().joined) {
      if (mode === 'session') { try { sessionStorage.setItem(KEY, '1'); } catch (e) {} }
      else if (mode !== '0') store.set({ until: Date.now() + Number(mode || 14) * 864e5 });
    }
    dialog.classList.remove('is-visible');
    const done = () => { dialog.close(); document.documentElement.classList.remove('abm-pop-lock'); };
    reduce() ? done() : setTimeout(done, 380);
  };

  const toE164 = (v) => {
    const d = v.replace(/\D/g, '');
    if (!d) return '';
    if (v.trim().startsWith('+')) return '+' + d;
    if (d.length === 10) return '+1' + d;
    if (d.length === 11 && d[0] === '1') return '+' + d;
    return '+' + d;
  };

  const bindForm = (form) => {
    form.addEventListener('submit', (e) => {
      if (!form.checkValidity()) { e.preventDefault(); form.reportValidity(); return; }
      const phone = form.querySelector('[data-abm-pop-phone]');
      const tags = form.querySelector('[data-abm-pop-tags]');
      if (phone) phone.value = toE164(phone.value);
      if (tags) tags.value = 'newsletter, popup-signup' + (phone && phone.value ? ', sms-opt-in' : '');
      form.querySelector('[data-abm-pop-errors]').hidden = true;
      form.querySelector('[type=submit]').setAttribute('aria-busy', 'true');
      // Native submit: Shopify attaches its spam-protection token and returns with ?customer_posted=true.
      // Leave the top layer so a captcha challenge, if shown, appears above the popup.
      requestAnimationFrame(() => { if (dialog.open && dialog.matches(':modal')) { dialog.close(); dialog.show(); dialog.classList.add('is-visible', 'is-sending'); } });
    });
  };

  const init = () => {
    dialog = document.querySelector('[data-abm-pop]');
    if (!dialog || dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    dialog.addEventListener('cancel', (e) => { e.preventDefault(); close(); });
    dialog.addEventListener('click', (e) => { if (e.target === dialog || e.target.closest('[data-abm-pop-close]')) close(); });
    const form = dialog.querySelector('[data-abm-pop-form]');
    if (form) bindForm(form);

    // Returning from a non-AJAX submit (e.g. after a captcha challenge)
    if (dialog.querySelector('[data-just-joined]')) {
      store.set({ joined: true });
      open(true);
      dialog.querySelector('[data-abm-pop-success] button')?.focus({ preventScroll: true });
      return;
    }
    if (/customer_posted=true/.test(location.search)) return;
    if (!dialog.querySelector('[data-abm-pop-errors]').hidden) { open(true); return; }
    if (dialog.dataset.design === 'true') return;

    if (/[?&]popup=1/.test(location.search)) { open(true); return; }
    // Count the delay from page start, not from when this deferred script ran.
    const wait = Math.max(0, Number(dialog.dataset.delay || 2) * 1000 - performance.now());
    timer = setTimeout(() => open(), wait);
    if (dialog.dataset.exit === 'true' && window.matchMedia('(pointer: fine)').matches) {
      document.addEventListener('mouseout', (e) => {
        if (!e.relatedTarget && e.clientY <= 0) { clearTimeout(timer); open(); }
      });
    }
  };

  init();
  document.addEventListener('shopify:section:load', (e) => { if (e.target.querySelector('[data-abm-pop]')) { dialog = null; init(); open(true); } });
  document.addEventListener('shopify:section:select', (e) => { if (e.target.querySelector('[data-abm-pop]')) open(true); });
  document.addEventListener('shopify:section:deselect', (e) => { if (e.target.querySelector('[data-abm-pop]')) close(false); });
})();
